export default __webpack_public_path__ + "static/media/Dipak Awasthi.2c569b22.jpg";